// extracted by mini-css-extract-plugin
export var container = "testimonials-module--container--90057";
export var image = "testimonials-module--image--02273";
export var item = "testimonials-module--item--92e03";
export var name = "testimonials-module--name--d9319";
export var next = "testimonials-module--next--e3b17";
export var pagination = "testimonials-module--pagination--0a548";
export var prev = "testimonials-module--prev--382c6";
export var section = "testimonials-module--section--ec268";
export var slide = "testimonials-module--slide--525eb";
export var slider = "testimonials-module--slider--841de";
export var text = "testimonials-module--text--c7ee9";
export var wrapper = "testimonials-module--wrapper--7fd30";